<!--
 * @Author: chengleilei
 * @Date: 2026-02-09 16:48:32
 * @Description: 客户管理-门店详情
-->
<template>
    <div v-loading="loading" class="pb-50">
        <PageHeader title="门店详情" hidden-breadcrumb>
            <div slot="back" @click="jumpPrevPage"><Icon type="md-arrow-back" /></div>
        </PageHeader>
        <Card :bordered="true" dis-hover class="ivu-mt">
            <Tabs type="card" class="bg-white" :animated="true" @on-click="changeTab">
                <TabPane label="门店信息" name="itemStore">
                    <List border size="large">
                        <ListItem>
                            <Col span="8">门店名称：</Col>
                            <Col>{{ storeInfo.storeName || '-' }}</Col>
                        </ListItem>
                        <ListItem>
                            <Col span="8">经销商：</Col>
                            <Col>{{ storeInfo.distributorName || '-' }}</Col>
                        </ListItem>
                        <ListItem>
                            <Col span="8">主营品牌：</Col>
                            <Col>{{ storeInfo.majorBrand || '-' }}</Col>
                        </ListItem>
                        <ListItem>
                            <Col span="8">副营品牌：</Col>
                            <Col>{{ storeInfo.secondaryBrand || '-' }}</Col>
                        </ListItem>
                        <ListItem>
                            <Col span="8">门头编号：</Col>
                            <Col>{{ storeInfo.storeSn || '-' }}</Col>
                        </ListItem>
                        <ListItem>
                            <Col span="8">门店维护人：</Col>
                            <Col>{{ storeInfo.salesmanName || '-' }}</Col>
                            <Button style="margin-left: 10px" type="warning" @click="changeProtector">变更</Button>
                        </ListItem>
                        <ListItem>
                            <Col span="8">所在区域：</Col>
                            <Col>{{ storeInfo.area || '-' }}</Col>
                        </ListItem>
                        <ListItem>
                            <Col span="8">详细地址：</Col>
                            <Col>{{ storeInfo.place || '-' }}</Col>
                        </ListItem>
                        <ListItem>
                            <Col span="8">联系手机号码：</Col>
                            <Col>{{ storeInfo.ownerPhone || '-' }}</Col>
                        </ListItem>
                        <ListItem>
                            <Col span="8">服务项目：</Col>
                            <Col>{{ storeInfo.serveNames || '-' }}</Col>
                        </ListItem>
                        <ListItem v-if="storeInfo.zhilunStoreId">
                            <Col span="8"> 绑定知轮门店ID：</Col>
                            <Col>{{ storeInfo.zhilunStoreId || '-' }}</Col>
                        </ListItem>
                        <ListItem v-if="storeInfo.bindingTime">
                            <Col span="8">绑定时间：</Col>
                            <Col>{{ storeInfo.bindingTime || '-' }}</Col>
                        </ListItem>
                    </List>
                </TabPane>
                <TabPane label="门店照片" name="storePhoto">
                    <StorePhoto :fileList="storePhotoList" />
                </TabPane>
                <TabPane label="地区" name="regionMap">
                    <RegionMap ref="regionMapRef" :mapForm="mapForm" :storeId="id" />
                </TabPane>
                <TabPane label="流动服务车" name="serviceCar">
                    <ServiceCar :storeInfo="storeInfo" />
                </TabPane>
                <TabPane label="变更记录" name="changeRecord">
                    <ChangeRecord />
                </TabPane>
                <TabPane label="巡店记录" name="cruiseRecord">
                    <CruiseRecord :storeId="id" />
                </TabPane>
                <TabPane label="店检记录" name="inspectionRecord">
                    <InspectionRecord :storeId="id" />
                </TabPane>
                <TabPane label="返利账户" name="rebateRecord">
                    <RebateRecord :storeId="id" />
                </TabPane>
                <TabPane label="积分账户" name="scoreRecord">
                    <ScoreRecord :storeId="id" />
                </TabPane>
                <TabPane label="公共资源库审核记录" name="pubAuditRecord">
                    <PubAuditRecord />
                </TabPane>
            </Tabs>
        </Card>
        <FooterToolbar>
            <Button @click="jumpPrevPage">返回</Button>
        </FooterToolbar>
        <ModalProtector ref="modalProtectorRef" @success="getData" />
    </div>
</template>

<script>
import ModalProtector from './components/ModalProtector';
import StorePhoto from './components/StorePhoto';
import RegionMap from './components/RegionMap';
import ServiceCar from './components/ServiceCar';
import ChangeRecord from './components/ChangeRecord';
import RebateRecord from './components/RebateRecord';
import ScoreRecord from './components/ScoreRecord';
import InspectionRecord from './components/InspectionRecord';
import CruiseRecord from './components/CruiseRecord';
import PubAuditRecord from './components/PubAuditRecord';
import { apiStoreDetail } from '@/api/store';
import { jumpPage, transPathToName } from '@/libs/util';

export default {
    components: {
        ModalProtector,
        StorePhoto,
        RegionMap,
        ServiceCar,
        ChangeRecord,
        RebateRecord,
        ScoreRecord,
        InspectionRecord,
        CruiseRecord,
        PubAuditRecord,
    },
    data() {
        return {
            id: this.$route.query.id || '',
            showModal: false,
            loading: false,
            storeInfo: {},
            storePhotoList: [],
            mapForm: {},
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        // 获取详情数据
        async getData() {
            const res = await apiStoreDetail(this.id);
            this.storeInfo = res;
            this.storeInfo.area = res.storeAddress.includes('区')
                ? res.storeAddress.split('区')[0] + '区'
                : res.storeAddress;
            this.storeInfo.place = res.storeAddress.includes('区') ? res.storeAddress.split('区')[1] : res.storeAddress;
            this.storeInfo.majorBrand = res.majorBrand
                .map((item) => {
                    return item.brandName;
                })
                .join(', ');
            this.storeInfo.secondaryBrand = res.secondaryBrand
                .map((item) => {
                    return item.brandName;
                })
                .join(', ');
            this.mapForm = res;
            this.mapForm.lat = res.storeLatitude;
            this.mapForm.lng = res.storeLongitude;
            this.mapForm.address = res.storeAddress;
            this.mapForm.areaIds = res.areaIds;
            this.storePhotoList = res.headImageUrl ? [{ url: res.headImageUrl }] : [];
        },
        jumpPrevPage() {
            window.$basePageStore.closeTab(transPathToName(location.pathname));
            jumpPage({ path: '/sub-vue2/customer/manage/list' });
        },
        // 打开修改维护人弹窗
        changeProtector() {
            this.$refs['modalProtectorRef'].open('ONE', this.storeInfo);
        },
        // change-tab
        changeTab(name) {
            this.$refs[`${name}Ref`]?.getData();
        },
    },
};
</script>

<style scoped></style>
